/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button, Icon, WhiteSpace } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import Theme from "../../utils/Theme";

const StyledContainer = styled.div`
  max-width: ${Theme.MaxWidth};
  overflow-x: hidden;
  background: white;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledBackContainer = styled.div`
  padding: 0.6em 0.6em
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-self: flex-start;
`;

const StyledContentContainer = styled.div`
  margin-top: 50px;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledIconContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: bold;
`;

const StyledIcon = styled.img`
  width: 5.5em;
`;

const StyledFloatIcon = styled.img`
  width: 1.5em;
  position: absolute;
  right: -10px;
  top: -10px;
`;

const StyledTitle = styled.span`
  font-size: 0.88em;
  color: grey;
`;

const StyledSeperator = styled.hr`
  width: 120%;
  background: lightgrey;
  margin-left: -10%;
`;

const StyledChangeLanguage = styled.span`
  font-size: 1.3em;
  font-weight: bold;
  line-height: 2em;
`;

const StyledSpaceAroundContainer = styled.div`
  margin: 30px 0 50px 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

const StyledButton = styled(Button)`
  width: 100%;
  && {
    cursor: pointer;
    color: white !important;
    font-size: 1em !important;
    border-radius: 25px !important;
    background-color: ${Theme.PrimaryColor};
  }
`;

class LanguagePage extends Component {
  constructor(props) {
    super(props);

    const { intl } = this.props;

    this.state = {
      animationClass: null,
      selectedLanguage: "en",
      languages: [
        {
          id: "en",
          title: intl.formatMessage({
            id: "language.english.title",
            defaultMessage: "English.",
            description: "Language English Title"
          }),
          src: require("../../assets/icons/flag_us.png")
        },
        {
          id: "ms",
          title: intl.formatMessage({
            id: "language.melayu.title",
            defaultMessage: "Bahasa Melayu.",
            description: "Language Melayu Title"
          }),
          src: require("../../assets/icons/flag_malaysia.png")
        },
        {
          id: "zh",
          title: intl.formatMessage({
            id: "language.chinese.title",
            defaultMessage: "Chinese.",
            description: "Language Chinese Title"
          }),
          src: require("../../assets/icons/flag_china.png")
        }
      ]
    };
  }

  componentDidMount() {
    const { currentLanguage } = this.props;

    this.setState({
      animationClass: "slide-in-down",
      selectedLanguage: currentLanguage ? currentLanguage : "en"
    });
  }

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-down" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  onSubmit = () => {
    const { selectedLanguage } = this.state;
    const { changeLanguage } = this.props;

    changeLanguage(selectedLanguage);
    this.onBackPressed();
  };

  render() {
    const { animationClass, selectedLanguage, languages } = this.state;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        <StyledBackContainer
          className={"underline"}
          onClick={this.onBackPressed}
        >
          <Icon type="left" size="xs" />
          <FormattedMessage
            id="app.back"
            defaultMessage="Back"
            description="Navigate to previous page"
          />
        </StyledBackContainer>
        <StyledContentContainer>
          {languages.map(item => {
            if (item.id === selectedLanguage) {
              return (
                <StyledIconContainer className={"opacity"}>
                  <StyledIcon src={item.src} />
                  <StyledFloatIcon
                    src={require("../../assets/icons/complete_orange.png")}
                  />
                  <WhiteSpace size={"xl"} />
                  {item.title}
                </StyledIconContainer>
              );
            }
          })}
          <WhiteSpace size={"lg"} />
          <StyledTitle>
            <FormattedMessage
              id="language.title"
              defaultMessage="Your primary language. This app and information will be in this language."
              description="Language Title"
            />
          </StyledTitle>
          <WhiteSpace size={"lg"} />
          <StyledSeperator />
          <StyledChangeLanguage>
            <FormattedMessage
              id="language.change.title"
              defaultMessage="Change other languages?"
              description="Language change languages Title"
            />
          </StyledChangeLanguage>
          <StyledSpaceAroundContainer>
            {languages.map(item => {
              if (item.id !== selectedLanguage) {
                return (
                  <StyledIconContainer
                    className={"opacity"}
                    onClick={() => this.setState({ selectedLanguage: item.id })}
                  >
                    <StyledIcon src={item.src} />
                    <WhiteSpace size={"xl"} />
                    {item.title}
                  </StyledIconContainer>
                );
              }
            })}
          </StyledSpaceAroundContainer>
          <StyledButton
            activeStyle={{ backgroundColor: Theme.ActivePrimary }}
            onClick={() => this.onSubmit()}
          >
            <FormattedMessage id="app.done" defaultMessage="Done" />
          </StyledButton>
        </StyledContentContainer>
      </StyledContainer>
    );
  }
}

LanguagePage.propTypes = {
  intl: PropTypes.func.isRequired,
  currentLanguage: PropTypes.string.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default injectIntl(LanguagePage);



// WEBPACK FOOTER //
// ./src/containers/LanguagePage/index.js